import React, { useState } from 'react'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import { Link } from 'react-router-dom'

const AddStudyMaterial = () => {



    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Add Study Material
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">


                            <main className="px-3 py-4">
                                <div className="study-material-sec">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                <div className="card" id="add-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-play" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0">Video Lession</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-image" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">Images</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="contact-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#contact"
                                                type="button"
                                                role="tab"
                                                aria-controls="contact"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-file-pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">Pdf</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content p-4" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            <div className="upload-icon-sec">
                                                <i
                                                    className="fa-solid fa-upload p-3"
                                                    style={{
                                                        backgroundColor: "aliceblue",
                                                        border: "1px solid",
                                                        borderRadius: "50%",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <h5>Upload Video</h5>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table bg-light mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No.</th>
                                                            <th scope="col">Video Name</th>
                                                            <th scope="col">Upload date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.mp4</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">2</th>
                                                            <td>bio.mp4</td>
                                                            <td>25-10-2024</td>
                                                            <td>Pending</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">3</th>
                                                            <td>bio.mp4</td>
                                                            <td>25-10-2024</td>
                                                            <td>Pending</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">4</th>
                                                            <td>bio.mp4</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">5</th>
                                                            <td>bio.mp4</td>
                                                            <td>25-10-2024</td>
                                                            <td>Pending</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            <div className="upload-icon-sec">
                                                <i
                                                    className="fa-solid fa-upload p-3"
                                                    style={{
                                                        backgroundColor: "aliceblue",
                                                        border: "1px solid",
                                                        borderRadius: "50%",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <h5>Upload Image</h5>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table bg-light mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No.</th>
                                                            <th scope="col">Image Name</th>
                                                            <th scope="col">Upload date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.jpg</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#imagesModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.jpg</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#imagesModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.jpg</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#imagesModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.jpg</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#imagesModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.jpg</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#imagesModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="contact"
                                            role="tabpanel"
                                            aria-labelledby="contact-tab"
                                        >
                                            <div className="upload-icon-sec">
                                                <i
                                                    className="fa-solid fa-upload p-3"
                                                    style={{
                                                        backgroundColor: "aliceblue",
                                                        border: "1px solid",
                                                        borderRadius: "50%",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <h5>Upload Pdf</h5>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table bg-light mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No.</th>
                                                            <th scope="col">Pdf Name</th>
                                                            <th scope="col">Upload date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.pdf</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#pdfModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.pdf</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#pdfModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.pdf</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#pdfModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.pdf</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#pdfModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">1</th>
                                                            <td>bio.pdf</td>
                                                            <td>25-10-2024</td>
                                                            <td>Approved</td>
                                                            <td>
                                                                <i
                                                                    className="fa-solid fa-eye "
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#pdfModal"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>



                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* video popup */}
                <div
                    className="modal fade"
                    id="videoModal"
                    tabIndex={-1}
                    aria-labelledby="videoModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="videoModalLabel">
                                    Notes Video
                                </h5>
                                <button
                                    type="button"
                                    className="-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src="https://www.youtube.com/embed/sample_video_id"
                                        title="YouTube video"
                                        allowFullScreen=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* images popup */}
                <div
                    className="modal fade"
                    id="imagesModal"
                    tabIndex={-1}
                    aria-labelledby="imagesModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="imagesModalLabel">
                                    Image Gallery
                                </h5>
                                <button
                                    type="button"
                                    className="-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {/* Left side: Main Image with navigation */}
                                    <div className="col-lg-8 col-md-8 position-relative">
                                        {/* Main Image */}
                                        <img
                                            id="mainImage"
                                            src="/assets/img/img1.jpg"
                                            className="img-fluid w-100 h-100 rounded"
                                            style={{ maxHeight: "500px !important" }}
                                            alt="Main Image"
                                        />
                                        {/* Left arrow */}
                                        <button
                                            id="prevButton"
                                            className=" -dark position-absolute top-50 start-0 translate-middle-y"
                                            onclick="navigateImage(-1)"
                                        >
                                            <i className="bi bi-chevron-left" />
                                        </button>
                                        {/* Right arrow */}
                                        <button
                                            id="nextButton"
                                            className=" -dark position-absolute top-50 end-0 translate-middle-y"
                                            onclick="navigateImage(1)"
                                        >
                                            <i className="bi bi-chevron-right" />
                                        </button>
                                    </div>
                                    {/* Right side: Image Thumbnails in Grid */}
                                    <div className="col-lg-4 col-md-4">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* pdf popup */}
                <div
                    className="modal fade"
                    id="pdfModal"
                    tabIndex={-1}
                    aria-labelledby="pdfModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog  modal-dialog-centered modal-lg ">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="pdfModalLabel">
                                    PDF Viewer
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body " style={{ maxHeight: 500 }}>
                                <div className="ratio ratio-4x3">
                                    <iframe
                                        src="/assets/img/isomt.pdf"
                                        title="PDF Document"
                                        style={{ width: "100%", height: "100%", maxHeight: 470 }}
                                        frameBorder={0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>


        </div>
    )
}

export default AddStudyMaterial